<script setup>
import { defineProps } from 'vue';
const props = defineProps({
  path: {
    type: String,
    required: true
  },
  action: {
    type: Function,
  },
  position: {
    type: String,
    default: 'bottomRight',
  },
  textColor: {
    type: String,
    default: 'text-white',
  },
});
</script>

<template>
  <div
      class="fixed"
      :class="{
            'bottom-6 right-6': props.position === 'bottomRight',
            'bottom-6 left-6': props.position === 'bottomLeft',
            'top-6 right-6': props.position === 'topRight',
            'top-6 left-6': props.position === 'topLeft',
        }"
  >
    <router-link
        :to="props.path"
        class="flex items-center justify-center p-2 rounded-full shadow-lg bg-white {{ props.textColor }} hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:border dark:hover:bg-gray-800 dark:border-gray-800 transition-all focus:outline-none"
    >
      <slot></slot>
    </router-link>
  </div>
</template>

<style scoped>

</style>